module.exports = __webpack_public_path__ + "img/logo.25b63c0b.svg";